import request from '@/utils/request'

export function listByStore(storeId) {
    return request({
        url: `/tdcs/boards/store/${storeId}`,
        method: 'get'
    })
}

export function listAll(keyword) {
    return request({
        url: `/tdcs/boards`,
        method: 'get',
        params: { keyword: keyword }
    })
}